import { __wbg_getTime_46267b1c24877e30, __wbg_new0_f788a2397c7ca929, __wbg_newwithyearmonthday_03748851282a850d, __wbindgen_throw, __wbindgen_init_externref_table } from "./date_parser_bg.js";
import wasmPath from "WASM_PATH";

const { memory, parse_date, __wbindgen_export_0, __wbindgen_malloc, __wbindgen_realloc, __wbindgen_start } = await __turbopack_wasm__(wasmPath, () => wasm_622c9c1d73a3a2f3337608f6b8920063, {
    "./date_parser_bg.js": {
        "__wbg_getTime_46267b1c24877e30": __wbg_getTime_46267b1c24877e30,
        "__wbg_new0_f788a2397c7ca929": __wbg_new0_f788a2397c7ca929,
        "__wbg_newwithyearmonthday_03748851282a850d": __wbg_newwithyearmonthday_03748851282a850d,
        "__wbindgen_throw": __wbindgen_throw,
        "__wbindgen_init_externref_table": __wbindgen_init_externref_table,
    },
}
);

export { memory, parse_date, __wbindgen_export_0, __wbindgen_malloc, __wbindgen_realloc, __wbindgen_start };
